var map = {
	"./artists/comingsoon.png": 5947,
	"./artists/daydream-portfolio-1.png": 9061,
	"./artists/daydream-portfolio-10.jpg": 5273,
	"./artists/daydream-portfolio-2.jpg": 922,
	"./artists/daydream-portfolio-3.jpg": 4759,
	"./artists/daydream-portfolio-4.jpg": 3564,
	"./artists/daydream-portfolio-5.jpg": 1609,
	"./artists/daydream-portfolio-6.jpg": 8526,
	"./artists/daydream-portfolio-7.jpg": 11,
	"./artists/daydream-portfolio-8.jpg": 1664,
	"./artists/daydream-portfolio-9.jpg": 2797,
	"./artists/daydreamos.jpg": 9074,
	"./products/classy-cat-0.jpg": 2780,
	"./products/classy-cat-1.jpg": 8153,
	"./products/classy-cat-2.jpg": 4446,
	"./products/classy-cat-3.jpg": 9227,
	"./products/classy-cat-4.jpg": 6552,
	"./products/cyber-otter-0.jpg": 6584,
	"./products/cyber-otter-1.jpg": 901,
	"./products/cyber-otter-2.jpg": 5178,
	"./products/cyber-otter-3.jpg": 6567,
	"./products/cyber-otter-4.jpg": 5020,
	"./products/dragon-taste-0.jpg": 2337,
	"./products/dragon-taste-1.jpg": 4292,
	"./products/dragon-taste-2.jpg": 2099,
	"./products/dragon-taste-3.jpg": 5638,
	"./products/dragon-taste-4.jpg": 397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6070;